export var version = {
  lib: '2.10100.1',
  product: '2.10100.1',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts